var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-end-card"},[_c('hr'),_c('div',{staticClass:"content"},[_c('small',{staticClass:"buttons-message text-muted"},[_vm._v("End card controls")]),_c('button',{staticClass:"btn btn-sm btn-outline-secondary edit",attrs:{"type":"button"},on:{"click":_vm.toggleEndCard}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v("Toggle")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }